import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { wrap } from '@popmotion/popcorn'
import cn from 'classnames'

import { useInterval } from '../../hooks'
import styles from './slider.module.css'

const variants = {
  enter: (direction) => {
    return {
      opacity: 0,
    }
  },
  center: {
    zIndex: 1,
    opacity: 1,
  },
  exit: (direction) => {
    return {
      zIndex: 0,
      opacity: 0,
    }
  },
}

function SentenceSlider({ sentences = ['One…', 'Two…'] }) {
  const [[page, direction], setPage] = useState([0, 0])
  const [isHovering, setIsHovering] = useState(false)
  const sentenceIndex = wrap(0, sentences.length, page)
  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection])
  }

  useInterval(
    () => {
      paginate(1)
    },
    isHovering ? null : 5000
  )

  return (
    <div className={styles.wrapper}>
      <AnimatePresence initial={false} custom={direction}>
        <motion.div
          className={styles.sentence}
          key={page}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            opacity: { duration: 0.5 },
          }}
          onHoverStart={() => setIsHovering(true)}
          onHoverEnd={() => setIsHovering(false)}
          onPan={(e, { offset, velocity }) => {
            const swipe = swipePower(offset.x, velocity.x)
            if (swipe < -swipeConfidenceThreshold) {
              paginate(1)
            } else if (swipe > swipeConfidenceThreshold) {
              paginate(-1)
            }
          }}
        >
          {sentences[sentenceIndex]}
        </motion.div>
      </AnimatePresence>
      <nav className={styles.dots}>
        {sentences.map((s, i) => (
          <button
            className={cn(styles.dot, {
              [styles.current]: i === sentenceIndex,
            })}
            onClick={() => paginate(i - sentenceIndex)}
            key={`s${i}`}
          />
        ))}
      </nav>
    </div>
  )
}

export default SentenceSlider

const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => {
  return Math.abs(offset) * velocity
}
